import { ChangeDetectionStrategy, Component } from "@angular/core";
import { LookerRiskDashboardType } from "../../looker-risk-dashboard-type.enum";
import { HideFilters } from "../../models/analytics-hide-filters.enum";

@Component({
  selector: "app-risk-clinical-operations-dashboard-projects-at-a-glance",
  templateUrl: "./risk-clinical-operations-dashboard-projects-at-a-glance.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RiskClinicalOperationsDashboardProjectsAtAGlanceComponent {
  filters: string[] = ["Projects"];
  dashboardType = LookerRiskDashboardType.RISK_CLINICAL_OPERATIONS_DASHBOARD_PROJECTS_AT_A_GLANCE;
  hideFilters = [HideFilters.PROJECT_ID, HideFilters.ORG_ID, HideFilters.USER_ID, HideFilters.PROJECT_NAME];
}
